<!--
    Created by 程雨喵'mac on 2024/4/15.
    Copyright © 2024年 云柜-金星晖. All rights reserved.
    界面名称：充电管理-刷卡记录
-->
<style lang="less">
#device-use-record {
  .text-adorn-color {
    color: @adornColor;
  }
  .text-primary-color {
    color: @textColorPrimary;
    font-weight: 600;
  }
}
</style>

<template>
  <div id="device-use-record">
    <!-- 查询条件 -->
    <div>
      <yg-search-area
        ref="YgSearchArea"
        :show-info="false"
        :value="searchOption"
        @on-search="_clickSearch"
      />
    </div>
    <div>
      <yg-setting-area
        :items="settingItems"
        :total="page.total"
        :export-amount="settingExportIdList.length"
        :export-select-id-list="settingExportIdList"
        :export-condition="settingExportCondition"
        @on-click="_clickSetting"
      />
    </div>
    <div
      class="padding-primary-top"
    >
      <yg-table
        :columns="tableColumns"
        :data="tableData"
        :page="page"
        :row-class-name="mixinTableRowClassName"
        @on-row-expand="mixinTableOnRowExpand"
        @on-page-change="onChangePage"
        @on-selection="onChangeSelection"
      />
    </div>
    <!--弹窗：查看各类型订单-->
    <yg-order-list
      v-if="!!dialog.orderListModel"
      :parameter-type="dialog.parameterType"
      :type="dialog.orderListType"
      :model="dialog.orderListModel"
      @on-close="dialog.orderListModel = null"
      @on-sure="dialog.orderListModel = null"
    />
  </div>
</template>

<script>
// import DeviceApiSet from '@/request/api/DeviceApiSet';
// import DpApiSet from '@/request/api/DpApiSet';
import { CardUseRecordModel } from './model/CardUseRecordModel';
import pageTableExpandMixin from '@/libs/mixins/pageTableExpand';
import ColumnMixin from './mixin/tableColumn';
import commonPageDrawerMixin from '@/components/common/order-list/commonPageDrawerMixin';

export default {
  components: {},
  mixins: [ColumnMixin, pageTableExpandMixin, commonPageDrawerMixin],
  props: {},
  data () {
    return {
      searchOption: {
        deviceNoLabel: BaseSearchModel.initData('用户手机号', 'deviceNoLabel', 'Input').setLabelSelect([
          { value: 'deviceNumber', label: '设备编码' },
          { value: 'tel', label: '用户手机号' },
          { value: 'cardNumber', label: '充电卡号' }
        ]),
        area: BaseSearchModel.initData('物业/小区/点位', 'area', 'YgSiteCascader').setData(1),
        time: BaseSearchModel.initData('刷卡时间', 'time', 'DatePickerRange').setDatePickerElevator([])
      },
      settingExportIdList: [],
      settingExportCondition: {},
      settingItems: [
        BaseSettingModel.initData('导出列表', 'downloadList', '').setExport().setExportReportType(6)
      ],
      page: { current: 1, total: 0 },
      tableData: [],
      dialog: {
        orderListModel: null,
        orderListType: null,
        parameterType: null
      }
    };
  },
  created () {},
  methods: {
    /** ******************* 工具方法开始 ******************* **/
    /** ******************* 工具方法结束 ******************* **/

    /** ******************* 回调事件开始 ******************* **/
    onChangePage (page) {
      this.page.current = page;
      this.requestData();
    },
    onChangeSelection (list) {
      // 1.先把本页的数据清掉
      let selectList = this.settingExportIdList.filter(v => this.tableData.findIndex(v1 => v1._checkId === v._checkId) === -1);
      if (list.length > 0) {
        // 本页有勾选项放进去
        selectList = [...selectList, ...list];
      }
      this.settingExportIdList = selectList;
    },
    /** ******************* 回调事件结束 ******************* **/

    /** ******************* 点击事件开始 ******************* **/
    _clickSearch (option) {
      console.log(option);
      this.searchOption = option;
      this.page.current = 1;
      this.requestData();
    },
    _clickSetting (key) {},
    /** ******************* 点击事件结束 ******************* **/

    /** ******************* 数据请求开始 ******************* **/
    requestData () {
      const s = this.searchOption;
      const api = {};
      api.params = {
        propertyCompanyId: s.area.value[0] || '',
        provinceName: s.area.value[1] || '',
        cityName: s.area.value[2] || '',
        communityId: s.area.value[3] || '',
        siteId: s.area.value[4] || '',
        timeStart: s.time.value[0],
        timeEnd: s.time.value[1],
        pageNo: this.page.current,
        pageSize: this.$config.pageSize
      };
      // 筛选中可下拉的label
      api.params[s.deviceNoLabel.labelSelectValue] = s.deviceNoLabel.value;
      this.settingExportCondition = api.params;
      this.tableData = [];
      this.page.total = 0;
      setTimeout(() => {
        const resData = CardUseRecordModel.createFakeDataList();
        this.page.total = resData.total;
        this.tableData = CardUseRecordModel.initListWithDataList(resData.rows);
        CardUseRecordModel.checkModelIsSelect(this.tableData, this.settingExportIdList);
      }, 100);
      // this.$http(api).then(res => {
      //   const resData = res.data;
      //   this.page.total = resData.total;
      //   this.tableData = DeviceUseRecordModel.initListWithDataList(resData.rows);
      // });
    }
    /** ******************* 数据请求结束 ******************* **/
  }
};
</script>
